export {reducer as game} from './game-rdx-client';
export {reducer as online} from './online-rdx-client';
export {reducer as room} from './room-rdx-client';
export {reducer as rooms} from './rooms-rdx-client';
export {reducer as user} from './user-rdx-client';
export {reducer as app} from './app-rdx-client';
export {reducer as error} from './error-rdx-client';
export {reducer as chat} from './chat-rdx-client';
export {reducer as animation} from './animation-rdx-client';
export {reducer as modal} from './modal-rdx-client';

//export data from './data';